import type { BBox } from '@okmaps/shared';
import { baseApi } from './baseApi.js';

export type PlaceKind = 'county' | 'city';

export interface Place {
  readonly name: string;
  readonly kind: PlaceKind;
  readonly bbox: BBox;
}

/**
 * Named places reduced to name and extent by the proxy.
 *
 * Cached for the session: Oklahoma's counties do not change while someone is
 * looking at a map, and the list is what the Locate autocomplete filters
 * against on every keystroke.
 */
export const placesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPlaces: build.query<readonly Place[], PlaceKind>({
      query: (type) => ({ url: 'places', params: { type } }),
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetPlacesQuery } = placesApi;
